var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingQuality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DEF3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#ADDFFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0799 15.1458C21.7003 15.1458 21.6038 14.8216 21.6038 14.2008V10.7933C21.6038 10.3518 21.1002 10 20.4932 10C19.8862 10 19.3827 10.3518 19.3827 10.7933V14.2008C19.3827 14.8216 19.3137 15.1458 17.8996 15.1458C17.8031 15.1458 17.7134 15.2079 17.7134 15.2838V17.2911C17.7134 17.36 17.8031 17.4221 17.9065 17.4221C18.803 17.469 19.6963 17.2837 20.5001 16.8841C21.3014 17.284 22.1926 17.4694 23.0868 17.4221C23.1903 17.4221 23.2731 17.36 23.2731 17.2911V15.2838C23.2593 15.2079 23.1834 15.1458 23.0799 15.1458Z",
    fill: "#121622",
    stroke: "#121622",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9065 19.8502C18.7539 18.8776 18.6664 17.8959 18.6444 16.9117C18.6444 14.4491 18.3202 11.1795 15.5059 11.1795C12.057 11.1795 9.19434 18.6913 9.19434 23.4095C9.19434 23.5543 9.19434 27.0653 10.3325 28.031C10.5243 28.198 10.7681 28.293 11.0223 28.3001C11.5745 28.2992 12.1107 28.1148 12.5467 27.7758C13.6236 27.0847 14.8221 26.6048 16.0784 26.3618C19.6722 25.534 19.2997 22.7818 18.9065 19.8502Z",
    fill: "#121622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.806 23.4307C31.806 18.7125 28.9158 11.2007 25.4944 11.2007C22.6801 11.2007 22.3559 14.4703 22.3559 16.9329C22.333 17.9102 22.2455 18.8849 22.0938 19.8507C21.7006 22.7616 21.3281 25.5138 24.8874 26.3623C26.1437 26.6053 27.3423 27.0852 28.4191 27.7763C28.8551 28.1153 29.3913 28.2997 29.9436 28.3006C30.2096 28.3017 30.467 28.2061 30.6678 28.0316C31.8267 27.0865 31.806 23.5755 31.806 23.4307Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingQuality);
export default __webpack_public_path__ + "static/media/breathing-quality.bd3288af1e0ca4b1e788ab2691e599c3.svg";
export { ForwardRef as ReactComponent };